import React from "react";
import styled from "styled-components";
import { fonts, colors, mediaQueries } from "../shared/config";
// import sneaker from "../assets/finalLanding.png";
import sneaker from "../assets/finalLanding.PNG";
import bg from "../assets/LandingBG.svg"
import Header from './Header'

const Background = styled.div`
    /* height:100%; */
    width: 100%;
    object-fit: fill;
    background-image: url(${bg});
    background-position: top;
    background-size: cover;
    padding: 100px 100px;

    ${mediaQueries.mobile} {
    /* flex-direction: row;
    align-items: center; */
    padding: 0 !important;
    }
  
`
const ColumnContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: auto;
    ${mediaQueries.mobile} {
    margin: 10px;
    }
    


`
const Container = styled.div`
  
  object-fit: fill;
  /* min-height: 80vh; */
  z-index: 999;
  /* padding-left: 5vw; */
  /* display: grid; */
  /* grid-template-columns: 200px auto; */
  
  /* justify-content: center !important;
  align-items: center !important; */
  display: flex;
  flex-direction: column;
  ${mediaQueries.mobile} {
    /* grid-template-columns: 1fr; */
    justify-content: center;
    flex-direction: column;
    padding-top: 10px;
  }
  ${mediaQueries.tablet} {
    /* grid-template-columns: 1fr; */
    justify-content: center;
    padding: 10px;
  }
  column-gap: 84px;
`;




const ImageContainer = styled.div`
  margin-top: -120px;
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;

  ${mediaQueries.tablet} {
    align-items: center;
    margin-top: 0;
  }
`;

const Image = styled.img`
  width: 100%;
  margin-top: 42px;
  /* margin-left: 100px; */
  ${mediaQueries.mobile} {
    width: 100% !important;
    align-items: center !important;
    margin-top: 0;
  }
  ${mediaQueries.tablet} {
    width: 100% !important;
    align-items: center !important;
    margin-top: 0;
  }
`;

const Credits = styled.div`
  font-family: ${fonts.credits};
  font-weight: 400;
  text-align: right;
  padding-left: 10px;
  font-size: 12px;
  padding-right: 10px;
  margin-top: -60px;
  ${mediaQueries.mobile} {
    text-align: right;
    margin-top: -30px;
    font-size: 8px;
  }
  ${mediaQueries.tablet} {
    text-align: right;
  }
`;

const Title = styled.div`
  font-size: 96px;
  line-height: 90%;
  font-family: Staatliches;
    margin: 0 0 0 auto;
  color: white;
  text-align: center;

  ${mediaQueries.tablet} {

    font-size: 80px;
  }
  ${mediaQueries.mobile} {

    font-size: 36px;
  }
`;

const Byline = styled.div`
  font-family: ${fonts.titles};
  font-weight: 400;
  text-align: right;
  padding-left: 10px;
  font-size: 48px;
  padding-right: 10px;
  text-align: center;
  color: white;
  ${mediaQueries.mobile} {
  padding-bottom:10px;
  font-size: 25px;
} 

`;


export default function NewLanding(props) {
  return(
    <Background>
        <ColumnContainer>
            <Container>
                {/* <Title>{props.title}</Title> */}
                <ImageContainer>
                    <div>
                        <Image src={sneaker} alt="sneaker"></Image>
                        <Credits> {props.credits} </Credits>
                    </div>

                </ImageContainer>
                <Title>{props.title}</Title>
            </Container>
            <Byline>By {props.byline}</Byline>
        
        </ColumnContainer>
        
      

     </Background>



  )};